import React, { useEffect, useRef } from 'react';

//
// <ScrollProgress/> — fixed-top teal indicator that tracks page scroll.
// Writes progress (0 → 1) into the CSS custom property `--scroll-progress`
// on its own root element; the visual bar is driven by `.scroll-progress`
// styles in index.css, so this stays cheap (no re-renders, rAF-throttled).
//
export default function ScrollProgress() {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;

    let raf = 0;
    const update = () => {
      raf = 0;
      const max = Math.max(
        1,
        (document.documentElement.scrollHeight || 0) - window.innerHeight
      );
      const p = Math.min(1, Math.max(0, window.scrollY / max));
      el.style.setProperty('--scroll-progress', p.toFixed(4));
    };
    const onScroll = () => {
      if (raf) return;
      raf = requestAnimationFrame(update);
    };

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  return <div ref={ref} className="scroll-progress" aria-hidden="true" />;
}
